import {STRATEGY_NAMES, STRATEGY_VALUES, StrategyKind} from '@/api/models/Scripts.ts';
import {Button, MenuItem} from '@blueprintjs/core';
import {ItemRenderer, Select} from '@blueprintjs/select';
import {ReactElement, useCallback} from 'react';

export type StrategySelectFn = (kind: StrategyKind) => void;

interface Props {
	selected: StrategyKind | null,
	onSelect?: StrategySelectFn,
	fill?: boolean,
	disabled?: boolean,
}

export default function StrategySelect({onSelect, selected, fill = true, disabled = false}: Props): ReactElement {
	const itemRenderer: ItemRenderer<StrategyKind> = useCallback((item, {handleClick, handleFocus, modifiers}) => {
		if (!modifiers.matchesPredicate)
			return null;

		return (
			<MenuItem
				key={item}
				text={STRATEGY_NAMES[item]}
				onClick={handleClick}
				onFocus={handleFocus}
				active={modifiers.active}
				selected={item === selected}
				roleStructure="listoption"
			/>
		);
	}, [selected]);

	return (
		<Select
			items={STRATEGY_VALUES}
			itemRenderer={itemRenderer}
			itemPredicate={itemPredicate}
			onItemSelect={onSelect}
			popoverProps={{
				matchTargetWidth: true,
			}}
			fill={fill}
			disabled={disabled}
		>
			<Button
				alignText="start"
				text={selected ? STRATEGY_NAMES[selected] : 'Select a strategy...'}
				fill={fill}
				endIcon="chevron-down"
				disabled={disabled}
			/>
		</Select>
	);
}

function itemPredicate(query: string, item: StrategyKind): boolean {
	return STRATEGY_NAMES[item].toLocaleUpperCase().includes(query.toLocaleLowerCase());
}
